import { createContext, Dispatch } from 'react'
import { DomainNotificationsProviderAction, DomainNotificationsProviderState } from './types'

export const DomainNotificationsProviderContext = createContext<{
    state: DomainNotificationsProviderState
    dispatch: Dispatch<DomainNotificationsProviderAction>
}>(null!)
